<template>
  <div class="home-automation-page">
    <iframe v-if="token" :src="src" class="page-container"></iframe>
    <section v-else class="loading loading-spinner">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <h1>Loading</h1>
    </section>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";

export default {
  data() {
    return {
      token: null
    };
  },
  computed: {
    src() {
      const baseURL = this.getHomeAutomationWebBaseUrl();

      return `${baseURL}?token=${this.token}`;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    async setupData() {
      this.token = await this.fetchToken();
    },
    async fetchToken() {
      const response = await baanRueJaiClient.admin.homeAutomation.accessToken();

      return response.data.accessToken;
    },
    getHomeAutomationWebBaseUrl() {
      return process.env.HOME_AUTOMATION_WEB_BASE_URL
    }
  }
};
</script>

<style lang="scss" scoped>
.home-automation-page,
.page-container,
.loading {
  width: 100%;
  height: 100vh;
}

.loading {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #444;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #444 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
